module.exports = __webpack_public_path__ + "img/img_logo_negro.f4c36a3b.svg";